import { defineCustomElement } from '../chunks/vidstack-SU9Igk1e.js';
import { MediaAudioLayoutElement } from './templates/vidstack-audio-layout.js';
import { MediaVideoLayoutElement } from './templates/vidstack-video-layout.js';
import { MediaPlyrLayoutElement } from './templates/plyr-layout.js';
import '../chunks/vidstack-GVXdqWu9.js';
import '../chunks/vidstack-Do9HXrsy.js';
import '../chunks/vidstack-CDhZT2hV.js';
import '@floating-ui/dom';
import 'lit-html';
import '../chunks/vidstack-CSXkYvDj.js';
import 'lit-html/directives/if-defined.js';
import 'lit-html/directives/unsafe-svg.js';
import 'lit-html/async-directive.js';
import '../chunks/vidstack-C07IaTje.js';
import '../chunks/vidstack-BOTZD4tC.js';
import 'lit-html/directives/ref.js';
import '../chunks/vidstack-DO-w-l5s.js';
import '../chunks/vidstack-BBt-iqE1.js';
import '../chunks/vidstack-D2YigfqZ.js';
import 'lit-html/directives/keyed.js';
import '../chunks/vidstack-wlwRLL8E.js';
import 'lit-html/directives/unsafe-html.js';

defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
defineCustomElement(MediaPlyrLayoutElement);
